export { default as FaqsDialog } from "./components/FaqsDialog";
export { default as FaqsContainer } from "./components/FaqsContainer";
export { dialogTexts } from "./constants";
export type { Faq } from "./types";
